import React, {ReactElement} from "react"

const TrackIcon = (): ReactElement => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_1051_59050)">
				<path
					d="M30.576 40.7113L21.7326 37.3166C17.7016 35.7692 17.195 30.2711 20.8753 28.0131L23.609 26.3358C27.5455 23.9207 26.6253 17.9572 22.144 16.8408L19.81 16.2594"
					stroke="url(#paint0_linear_1051_59050)" strokeWidth="5.2093" strokeLinecap="round"/>
				<path
					d="M3.46481 11.8179C2.11047 10.1779 3.18662 7.69372 5.30941 7.55996L15.0958 6.94331C17.8473 6.76993 18.9469 10.4312 16.5551 11.8024L15.1052 12.6337C14.1044 13.2075 13.6002 14.3712 13.8662 15.4938L14.2515 17.1201C14.887 19.8028 11.464 21.5049 9.70856 19.379L3.46481 11.8179Z"
					fill="#F23C3C"/>
				<circle cx="31.5" cy="9" r="3" fill="#F23C3C"/>
			</g>
			<defs>
				<linearGradient id="paint0_linear_1051_59050" x1="16.9306" y1="18.0613" x2="34.5436" y2="38.5409"
				                gradientUnits="userSpaceOnUse">
					<stop offset="0.0306724" stopColor="#F13B3B"/>
					<stop offset="1" stopColor="#8B2222"/>
				</linearGradient>
				<clipPath id="clip0_1051_59050">
					<path
						d="M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z"
						fill="white"/>
				</clipPath>
			</defs>
		</svg>
	)
}

export default TrackIcon
